export function normalizeSizeForSort(opt: any): { widthMm: number; heightMm: number } {
  const widthMm = Number(opt?.widthMm || 0)
  const heightMm = Number(opt?.heightMm || 0)
  if (widthMm > 0 && heightMm > 0) {
    return { widthMm: Math.round(widthMm), heightMm: Math.round(heightMm) }
  }
  const match = String(opt?.title || '').replace(',', '.').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i)
  if (match) {
    return {
      widthMm: Math.round(parseFloat(match[1]) * 10),
      heightMm: Math.round(parseFloat(match[2]) * 10),
    }
  }
  return { widthMm: 300, heightMm: 200 }
}

export function compareSizeOptions(a: any, b: any): number {
  const normA = normalizeSizeForSort(a)
  const normB = normalizeSizeForSort(b)
  const widthA = Number(normA.widthMm || 0) || 0
  const widthB = Number(normB.widthMm || 0) || 0
  const heightA = Number(normA.heightMm || 0) || 0
  const heightB = Number(normB.heightMm || 0) || 0
  const hasDimsA = widthA > 0 && heightA > 0
  const hasDimsB = widthB > 0 && heightB > 0
  if (hasDimsA !== hasDimsB) return hasDimsA ? -1 : 1

  const byWidth = widthA - widthB
  if (byWidth !== 0) return byWidth

  const byHeight = heightA - heightB
  if (byHeight !== 0) return byHeight

  const priceA = Number(a?.priceSpecial ?? a?.price ?? 0) || 0
  const priceB = Number(b?.priceSpecial ?? b?.price ?? 0) || 0
  const byPrice = priceA - priceB
  if (byPrice !== 0) return byPrice

  return String(a?.title || '').localeCompare(String(b?.title || ''), 'de')
}
